import TiltMessage from "../../../components/feedback/TiltMessage";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { SectionHeader } from "../../SectionHeader";
import { RetailAOVFrequency } from "../components/retail-AOV";
import { RetailCustomerSegmentation } from "../components/retail-CustomerSegment";
import { RetailRegionalDemographics } from "../components/retail-RegionalAnalysis";




export function RetailCustomer() {
    const showTiltMessage = useIsPortraitMobile();


    return (
        <>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Customer Insights" />
                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <RetailCustomerSegmentation />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <RetailAOVFrequency />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <RetailRegionalDemographics />
                    </div>
                </ModuleGrid>
            </div>
        </>
    )
}